<template>
    <div class="tabs">
        <div v-if="tabs.length > 1 || slots.length > 1" class="tabs__header mt-4 mb-4" :class="classTabs">
            <ul class="tabsList">
                <template v-for="(tab, index) in slots" :key="index">
                    <li class="tabsList__item">
                        <a
                            :href="tab.props.url"
                            class="tabsList__link"
                            :class="{ 'tabsList__link--active': tab.props['tab-id'] === selectedTabId }"
                            :data-cy="`${tab.props['tab-id']}`"
                            @click.prevent="selectTab(tab.props['tab-id'])"
                        >
                            {{ tab.props.title }}
                        </a>
                    </li>
                </template>
            </ul>
        </div>
        <slot></slot>
    </div>
</template>

<script lang="ts">
export default {
    props: {
        activeTabId: {
            type: String,
            required: true,
        },
        classTabs: {
            type: String,
            default: 'tabs__header--fullWidth',
        },
    },

    data() {
        return {
            selectedTabId: 0,
            tabs: [],
        }
    },

    computed: {
        slots() {
            if (this.$slots.default()[0].children.filter) {
                return this.$slots
                    .default()[0]
                    .children.filter((child: any) => child.type.name === 'PilulkaTab' || child.type.name === 'ElementsPilulkaTab')
            }

            const resultSlots: any[] = []
            this.$slots.default().forEach((child: any) => {
                if (child.type.name === 'PilulkaTab') {
                    resultSlots.push(child)
                } else if (child.children.filter) {
                    child.children.forEach((child2: any) => {
                        resultSlots.push(child2)
                    })
                }
            })

            return resultSlots
        },
    },

    watch: {
        activeTabId: {
            immediate: true,
            handler(newValue) {
                this.selectTab(newValue)
            },
        },
    },

    mounted() {
        useNuxtApp().$bus.$on('setActiveTab', (tabId: number) => {
            this.selectTab(tabId)

            setTimeout(() => {
                const tabsPosition = document.getElementById('tabsHeader')?.offsetTop || 0
                const pagePosition = window?.pageYOffset ?? 0
                const heightWindow = window?.innerHeight ?? 860
                const overPosition = (heightWindow / 4) * 2 + pagePosition
                const idealPosition = tabsPosition - heightWindow / 4
                if (tabsPosition > overPosition || pagePosition > tabsPosition) {
                    window.scrollTo(0, idealPosition)
                }
            }, 150)
        })
        this.selectTab(this.activeTabId)
    },

    methods: {
        selectTab(tabId: number) {
            this.selectedTabId = tabId
            setTimeout(() => {
                this.tabs.forEach((tab: any) => {
                    if (tab.tabId === tabId) {
                        tab.select()
                    } else {
                        tab.unselect()
                    }
                })
            }, 0)
        },
    },
}
</script>

<style lang="scss" scoped>
.tabs__header {
    margin: 1rem 0 0 0;
    overflow-x: auto;
    white-space: nowrap;

    &--fullWidth {
        width: calc(100% + 2 * $padding-container-inside-mobile);
        margin-left: -$padding-container-inside-mobile;
        padding: 0 $padding-container-inside-mobile 1rem $padding-container-inside-mobile;

        @media (min-width: 576px) {
            width: calc(100% + 40px);
            max-width: calc($max-width-container-inside + 40px);
            margin-left: -20px;
            padding: 0 20px 1rem 20px;
        }

        @media (min-width: $max-width-container-inside) {
            margin-left: 0;
            width: 100%;
            max-width: $max-width-container-inside;
            padding: 0;
        }
    }

    &--homepage {
        width: calc(100% + 2 * $padding-container-inside-mobile);
        margin-left: -$padding-container-inside-mobile;
        padding: 0 $padding-container-inside-mobile;
        margin-bottom: 10px !important;

        @media (min-width: 576px) {
            width: calc(100% + 40px);
            max-width: calc($max-width-container-inside + 40px);
            margin-left: -20px;
            padding: 0 20px;
        }

        @media (min-width: 768px) {
            width: auto;
            margin: 0;
            padding: 0;
        }
    }
}

.tabsList {
    display: inline-flex;
    list-style: none;
    padding: 0;
    margin: 0;
}

.tabsList__item {
    overflow: hidden;

    &:first-child {
        border-top-left-radius: $border-radius;
        border-bottom-left-radius: $border-radius;
    }

    &:last-child {
        border-top-right-radius: $border-radius;
        border-bottom-right-radius: $border-radius;
    }
}

.tabsList__link {
    display: inline-block;
    padding: 0 0.875rem;
    font-size: 0.875rem;
    line-height: 2.5rem;
    background-color: $color-grey;
    cursor: pointer;
    color: $color-dark;
    font-weight: 600;

    &:hover {
        @media (min-width: 1024px) {
            background-color: $color-grey-dark;
        }
    }

    &--active {
        background-color: $color-cta-extra-light;
    }
}
</style>
